package com.ilussobsa.views

import com.ilussobsa.Strings
import com.ilussobsa.sdk.currentUserSessionNullable
import com.ilussobsa.tutorialsComplete
import com.lightningkite.kiteui.Routable
import com.lightningkite.kiteui.models.rem
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.lightningdb.modification
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*

@Routable("/tutorial/{id}")
class TutorialScreen(val id: TutorialItem) : Page {
    override val title: Reactive<String> get() = id.title.let(::Constant)
    override fun ViewWriter.render() = pageWithMaxWidth(60.rem) {
        scrolling - col {
            id.render(this)
            important - button {
                centered - text(Strings.markComplete)
                onClick {
                    currentUserSessionNullable()?.let {
                        it.user[it.userId].modify(modification {
                            it.tutorialsComplete.addAll(setOf(id.name))
                        })
                    }
                    navigator.goBack()
                }
            }
        }
    }
}